import React from 'react';
import Lozenge, { type ThemeAppearance } from '@atlaskit/lozenge';
import type { CmdbObjectAttributeStatus } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export type Props = {
	attribute: CmdbObjectAttributeStatus;
};

export const inferThemeAppearanceFromCategory = (category?: number): ThemeAppearance => {
	switch (category) {
		case 0:
			return 'removed';
		case 1:
			return 'success';
		case 2:
			return 'moved';
		default:
			return 'default';
	}
};

export const StatusAttribute = ({ attribute }: Props): React.JSX.Element => (
	<>
		{attribute.objectAttributeValues.map((value, index) => {
			const appearance = inferThemeAppearanceFromCategory(value.status.category);

			return (
				<Lozenge key={index} isBold appearance={appearance}>
					{value.displayValue}
				</Lozenge>
			);
		})}
	</>
);
